import React, { useEffect, useState, useMemo, useCallback } from 'react'
import Breadcrumb from '../../../Components/Breadcrumbs'
import { Box, InputLabel, Select, Typography, FormControl, MenuItem, TextField } from '@material-ui/core'
import useStyles from './style'
import CustomGraphs from './CustomGraphs'
import debounce from 'lodash/debounce'

const ForeCastGraphs = () => {
  const classes = useStyles()
  const [ granularity, setGranularity ] = useState("15mins")
  const [ duration, setDuration ] = useState("24H")
  const [site_ids, setSiteIds] = useState([])
  const [durationList, setDurationList] = useState(["24H"])
  const granularityList = ['15mins']
  const [siteId, setSiteId] = useState([])

  const transformAndSetSiteIds = useCallback((rawInput) => {
    const rawString = rawInput.trim();
    const stringArray = rawString.split(',');
    const finalArray = stringArray.map(id => id.trim()).filter(id => id.length > 0);
    setSiteIds(finalArray);
  }, [])

  const debouncedChangeHandler = useMemo(
    () => debounce(transformAndSetSiteIds, 1000),
    [transformAndSetSiteIds]
  )

  useEffect(() => {
    return () => {
      debouncedChangeHandler.cancel()
    }
  }, [debouncedChangeHandler])


  return (
    <>
      <Breadcrumb value={[{ 'VPP': '/vpp' }, { 'Forecast Graphs': '/vpp/forecast-graphs' }]} />
      <Box className={classes.headerWrapper}>
        <Typography className={classes.title}>VPP Energy Forecast </Typography>
        <Box className={classes.subHeadingWrapper}>
          <TextField 
            id="site_ids" 
            label="Site Id's" 
            placeholder='Enter Site Ids' 
            value={siteId} 
            multiline
            rows={1}   
            maxRows={10000}
            InputLabelProps={{
              shrink: true, 
            }}
            onChange={(e) => {
              const value = e.target.value;        
              setSiteId(value.trim()); 
              debouncedChangeHandler(value);
            }} 
          />
          <Box width="20px"></Box>
          <FormControl >
            <InputLabel id="granularity-label" >Granularity</InputLabel>
            <Select
              labelId="granularity-label"
              id="granularity"
              classes={{ root: classes.selectRoot }}
              value={granularity}
              onChange={(e) => setGranularity(e.target.value)}
              MenuProps={{
                anchorOrigin: {
                  vertical: "bottom",
                  horizontal: "left"
                },
                getContentAnchorEl: null
              }}
            >
                {granularityList.map((item) => <MenuItem id={item} value={item}>{item}</MenuItem>)}
            </Select>
          </FormControl>
          <Box width="20px"></Box>
          <FormControl >
            <InputLabel id="duration-label" >Duration</InputLabel>
            <Select
              labelId="duration-label"
              id="duration"
              value={duration}
              classes={{ root: classes.selectRoot }}
              onChange={(e) => setDuration(e.target.value)}
              MenuProps={{
                PaperProps: {
                  style: {
                    maxHeight: 250, 
                    width: 100
                  },
                },
                anchorOrigin: {
                  vertical: "bottom",
                  horizontal: "left"
                },
                getContentAnchorEl: null
              }}
            >
                {durationList.map((item) => <MenuItem id={item} value={item}>{item}</MenuItem>)}
            </Select>
          </FormControl>
        </Box>
      </Box>
      <Box style={{display: 'flex'}}>
        <CustomGraphs duration={duration} setDuration={setDuration} granularity={granularity}setGranularity={setGranularity} site_ids={site_ids} />
      </Box>
    </>
  )
}

export default ForeCastGraphs